"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WishlistStateValidator = void 0;
const incorrect_wishlist_state_1 = require("../exceptions/incorrect-wishlist-state");
class WishlistStateValidator {
    validate(wishlist, expectedState) {
        if (wishlist.stateHash !== expectedState) {
            throw new incorrect_wishlist_state_1.IncorrectWishlistState();
        }
    }
}
exports.WishlistStateValidator = WishlistStateValidator;
